import { render, staticRenderFns } from "./NewEditTeleMedicine.vue?vue&type=template&id=05ac47c4"
import script from "./NewEditTeleMedicine.vue?vue&type=script&lang=js"
export * from "./NewEditTeleMedicine.vue?vue&type=script&lang=js"
import style0 from "./NewEditTeleMedicine.vue?vue&type=style&index=0&id=05ac47c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports